export { StaticMapBox } from './StaticMapBox'
